import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";

export default function useSocket() {
	const { socket, setSocket } = useContext(AppContext);
	return {socket, setSocket};
}